import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { ScrollArea } from "@/components/ui/scroll-area";
import { FileText } from "lucide-react";
import logoIcon from "@/assets/regard-de-nature-logo.png";
import { BRAND } from "@/config/brand";

export function CGV() {
  return (
    <Sheet>
      <SheetTrigger asChild>
        <button className="hover:text-primary transition-colors text-left">CGV</button>
      </SheetTrigger>
      <SheetContent side="right" className="w-full sm:max-w-2xl p-0">
        <div className="p-6 border-b border-border">
          <div className="flex items-center gap-3 mb-4">
            <img src={logoIcon} alt={BRAND.name.full} className="w-12 h-12" />
            <div>
              <h2 className="text-2xl font-bold text-primary font-serif">{BRAND.name.full}</h2>
              <p className="text-xs text-accent uppercase tracking-wide">{BRAND.baseline.full}</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <FileText className="w-5 h-5 text-primary" />
            <h3 className="text-xl font-semibold text-primary">Conditions Générales de Vente</h3>
          </div>
        </div>
        <ScrollArea className="h-[calc(100vh-180px)] p-6 pb-12">
          <div className="space-y-6 text-sm">
            <div className="space-y-3">
              <p className="font-semibold text-primary">
                Les présentes conditions générales de vente s'appliquent entre :
              </p>
              <p className="font-semibold">D'UNE PART</p>
              <p>
                REGARD DE NATURE – Naturopathie pour petits & grands, Auto-entrepeneur, ayant son siège social au 31 rue de
                l'ancien petit fossé, 31450 Montesquieu-Lauragais.
                <br />
                Téléphone : 06 37 03 18 66
              </p>
              <p>dénommée ci-après « nous » ou « REGARD DE NATURE »</p>
              <p className="font-semibold">ET, D'AUTRE PART,</p>
              <p>
                tout particulier souhaitant procéder à un achat via le site Internet « REGARD DE NATURE » (ci-après « le
                site »), dénommée ci-après « vous ».
              </p>
              <p>
                Le site n'est pas destiné à la vente aux professionnels. Si des professionnels effectuent des commandes
                sur notre site, ces commandes seront considérées comme émanant de particuliers. Les professionnels sont
                invités à nous contacter directement en cliquant sur le lien suivant : contact@regard-de-nature.fr
              </p>
              <p>
                Toute utilisation de nos produits et matières premières à des fins commerciales, sans notre accord
                préalable, est interdite.
              </p>
              <p>
                Les présentes conditions générales s'appliquent à toute vente réalisée sur notre site, à l'exclusion de
                toutes autres conditions, notamment celles en vigueur pour les ventes en magasin. Ces conditions
                générales de vente pouvant faire l'objet de modifications à tout moment et sans préavis, les conditions
                applicables sont celles en vigueur sur le site à la date de passation de votre commande.
              </p>
              <p>
                Toute passation de commande implique l'acceptation de nos conditions d'utilisation du site et des
                présentes conditions générales de vente.
              </p>
            </div>

            <div className="space-y-3">
              <h4 className="font-semibold text-primary text-base">Article 1 – Prix, disponibilité</h4>
              <p>
                Les prix sont ceux affichés sur le site lors de la saisie de votre commande. REGARD DE NATURE se réserve
                le droit de modifier ses prix à tout moment mais les produits seront facturés sur la base des tarifs en
                vigueur au moment de votre validation de commande.
              </p>
              <p>
                Les prix indiqués sur le site sont en euros toutes taxes comprises (TVA et autres taxes) et incluent la
                participation aux frais de traitement de la commande.
              </p>
              <p>
                Ces prix s'entendent hors frais de livraison. Le montant des frais de livraison sera précisé sur le bon
                de commande avant validation de la commande. Les frais de livraison peuvent vous être offerts dans
                certains cas, selon les opérations de promotion qui vous seront signalées.
              </p>
              <p>
                Les commandes sont validées et traitées dans la limite des stocks disponibles. Dans ce cadre, des
                indications sur la disponibilité des produits seront fournies au client lors de sa commande. Aucune
                erreur sur cette disponibilité ne pourra entraîner notre responsabilité.
              </p>
            </div>

            <div className="space-y-3">
              <h4 className="font-semibold text-primary text-base">Article 2 – Commande</h4>
              <p>Les commandes sont passées sur le site internet « REGARD DE NATURE »</p>
              <p>
                Un e-mail de confirmation vous est envoyé par nos soins dès lors que vous passez une nouvelle commande
                sur le site. Votre commande n'est définitivement acceptée et la vente réalisée qu'après envoi de ce
                courriel de confirmation. Le bon de commande ainsi validé a une valeur contractuelle.
              </p>
              <p>Vous recevez également un autre courriel dès que cette même commande vous est expédiée.</p>
              <p>
                En cas d'indisponibilité temporaire ou permanente pour toute cause que ce soit après la passation de
                votre commande, vous en serez informé et aurez la possibilité d'annuler votre commande par simple
                courriel et de demander le remboursement des sommes versées, qui interviendra dans les 30 jours de la
                date de versement, ou le remplacement à valeur égale par un autre produit que vous choisirez dans le
                catalogue de REGARD DE NATURE.
              </p>
            </div>

            <div className="space-y-3">
              <h4 className="font-semibold text-primary text-base">Article 3 – Livraison</h4>
              <p>
                Les produits sont livrés à l'adresse indiquée sur le bon de commande. La facture peut être envoyée à une
                adresse différente de la livraison si vous le souhaitez.
              </p>
              <p>
                La commande sera expédiée sous le délai maximum de 5 jours ouvrables à compter de votre passation de
                commande, sauf pour les produits en « Précommande » (voir ci-dessous). A compter de l'expédition, le
                délai de livraison maximum sera de 6 jours ouvrable. Vous pouvez suivre votre commande grâce aux
                indications fournies dans la rubrique "mes commandes".
              </p>
              <p>
                Plusieurs formules de livraison pourront vous être proposées lors de votre commande et nous vous
                préciserons leurs coûts et leurs délais exacts.
              </p>
              <p>
                Pour les produits en « Précommande », l'expédition n'aura lieu qu'à la date de disponibilité desdits
                produits, qui sera par nature relativement éloignée (le plus souvent de 30 jours) de votre passation de
                commande.
              </p>
              <p>
                En toute hypothèse, la date de livraison prévue vous sera clairement indiquée avant votre passation de
                commande.
              </p>
              <p>
                Lors de la réception de votre commande, vous devrez en vérifier l'état et faire immédiatement
                réclamation s'il y a lieu ou refuser la livraison au livreur sous forme de réserve manuscrite.
              </p>
              <p>
                Vous devrez informer sans délai REGARD DE NATURE des défauts de conformité constatés, par courrier
                électronique ou par courrier postal à l'adresse mentionnée ci-dessous à l'article 5.
              </p>
            </div>

            <div className="space-y-3">
              <h4 className="font-semibold text-primary text-base">Article 4 – Paiement</h4>
              <p>
                Le règlement de vos achats en ligne s'effectue par cartes bancaires, chèque ou virement suivant détail
                figurant au bon de commande.
              </p>
              <p>
                Le règlement par cartes bancaires sera opéré par le biais du système bancaire sécurisé de notre banque.
                Aucun tiers n'a accès aux informations transmises. Les données relatives à votre carte bancaire seront
                conservées seulement pendant le traitement de votre commande.
              </p>
              <p>
                En cas de règlement impliquant un délai d'encaissement (chèque, virement), l'expédition ne sera
                effectuée qu'après encaissement complet de la commande.
              </p>
              <p>Nous ne prélevons aucun frais sur vos moyens de paiement.</p>
            </div>

            <div className="space-y-3">
              <h4 className="font-semibold text-primary text-base">Article 5 – Droit de rétractation et retour</h4>
              <p>
                Conformément à la loi, vous disposez d'un droit de rétractation de 14 jours à compter du jour de
                réception de la commande pour nous retourner les produits sans avoir à justifier de motif ni à payer de
                pénalité.
              </p>
              <p>
                Vous pouvez exercer ce droit en utilisant le modèle de lettre de rétractation qui est accessible en
                cliquant Formulaire de rétractation.
              </p>
              <p>
                Dans cette hypothèse, vous disposerez alors d'un délai légal maximum de 14 jours (suivant la
                communication de votre décision de vous rétracter) pour nous retourner, à vos frais, les produits
                concernés.
              </p>
              <p>
                Si nous avons récupéré ces produits, nous vous rembourserons dans les 14 jours suivant la date à
                laquelle vous nous aurez informé de votre décision de rétractation.
              </p>
              <p>
                Dans le cas contraire, le remboursement sera différé jusqu'au jour auquel nous aurons récupéré les
                produits ou jusqu'au jour où vous nous aurez fourni une preuve de l'expédition de ces produits.
              </p>
              <p>
                Si la commande est endommagée ou ne correspond visiblement pas aux produits demandés, vous disposez d'un
                délai de 21 jours à compter du jour de réception de la commande pour nous retourner les produits
                concernés. Nous nous engageons alors à les remplacer ou les rembourser dans les meilleurs délais. Afin
                de garantir cet échange ou remboursement, nous vous prions de bien vouloir nous adresser une lettre
                stipulant les raisons détaillées de votre retour et de nous retourner les articles dans leur état
                d'origine et complets (emballage, accessoires, notice...), accompagnés d'une copie de la facture
                d'achat.
              </p>
              <p>
                Les remboursements s'effectuent par chèque bancaire à votre nom ou par virement sur le compte auquel
                votre carte bancaire est rattachée.
              </p>
              <p className="font-semibold">Adresse de retour :</p>
              <p>
                31 rue de l'ancien petit fossé
                <br />
                31450 - Montesquieu-Lauragais
                <br />
                France
              </p>
            </div>

            <div className="space-y-3">
              <h4 className="font-semibold text-primary text-base">Article 6 – Responsabilité - Garantie</h4>
              <p>
                Nous vous invitons à vous reporter au descriptif de chaque produit pour en connaître les
                caractéristiques précises et en cas de doute ou si vous souhaitez des renseignements complémentaires
                n'hésitez pas à nous contacter.
              </p>
              <p>
                Les photos ou vidéos sont communiquées à titre illustratif et n'ont aucune valeur contractuelle. Notre
                responsabilité ne sera pas engagée en cas de différence entre les photos, vidéos ou illustrations de
                notre site internet et les produits commandés.
              </p>
              <p>
                Vous devez vérifier, auprès de votre médecin si nécessaire, que les produits que vous nous commandez
                sont compatibles avec votre régime alimentaire, vos éventuels problèmes de santé et notamment vos
                éventuelles allergies. Notre responsabilité ne pourra pas être engagée à cet égard.
              </p>
              <p>
                Notre responsabilité ne sera pas engagée en cas de mauvaise utilisation de nos produits. Vous devez
                respecter les conditions d'utilisations et les recommandations mentionnées sur l'emballage du produit
                consommé.
              </p>
              <p>
                Nous excluons toute garantie lorsque le vice allégué a pour origine une fausse manœuvre, une négligence
                ou une mauvaise utilisation, qui vous sont imputables.
              </p>
              <p>
                Nous excluons toute garantie pour les vices apparents dont vous ne vous seriez pas prévalu dans le délai
                de 21 jours suivant la livraison.
              </p>
              <p>
                En toute hypothèse, notre garantie est limitée au remboursement ou au remplacement du produit concerné.
              </p>
              <p>
                Notre responsabilité ne pourra être engagée pour aucun dommage indirect, tels que, notamment mais non
                limitativement, perte d'exploitation, de marchés, de clientèle, atteinte à l'image.
              </p>
              <p>
                Nous vous rappelons que vous bénéficiez de la garantie légale de conformité (articles L.217-4 et
                suivants du Code de la consommation) et de la garantie légale des vices cachés (articles 1641 et
                suivants du Code civil).
              </p>
              <p>Par ailleurs, nous ne pourrons être tenus responsables pour :</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>
                  les dommages directs ou indirects résultant de l'usage du site, de sa consultation, de l'utilisation
                  des informations disponibles sur celui-ci, à savoir notamment toute perte d'exploitation financière ou
                  commerciale ou perte de programme ou de données dans tout système d'informations et ce même si nous
                  avons été informés de l'éventualité de tels dommages ;
                </li>
                <li>les dysfonctionnements, impossibilité d'accès ou mauvaises conditions d'utilisation du site.</li>
              </ul>
            </div>

            <div className="space-y-3">
              <h4 className="font-semibold text-primary text-base">Article 7 – Droit applicable - Litiges</h4>
              <p>
                Le présent contrat est soumis à la loi française même dans le cas où celle-ci considérerait que la loi
                d'un autre pays doit s'appliquer. La langue du présent contrat est uniquement la langue française. En
                cas de contentieux, les tribunaux français seront seuls compétents, même en cas de pluralité de
                défendeurs ou d'appel en garantie.
              </p>
              <p>
                Nonobstant le paragraphe précédent et conformément à l'article L.133-4 du Code de la consommation nous
                vous informons que vous avez la possibilité de recourir, en cas de contestation, à une procédure de
                médiation conventionnelle ou à tout autre mode alternatif de règlement des différends. Vous pouvez
                contacter un médiateur en cliquant ici : https://www.cmap.fr/contact/
              </p>
              <p>
                Par ailleurs, conformément à l'article L.616-2 du Code de la consommation, nous vous informons de
                l'existence de la plateforme mise en ligne par la Commission européenne qui a pour objet de recueillir
                les éventuelles réclamations issues d'un achat en ligne des consommateurs européens et de transmettre
                ensuite les cas reçus aux médiateurs nationaux compétents.
              </p>
              <p>Ce lien est accessible en cliquant ici : http://ec.europa.eu/consumers/odr/</p>
              <p>
                Pour toute réclamation, vous vous engagez à informer par courriel REGARD DE NATURE afin que nous ayons
                la possibilité de vous proposer une solution amiable.
              </p>
            </div>

            <div className="space-y-3">
              <h4 className="font-semibold text-primary text-base">Article 8 – Données personnelles</h4>
              <p>
                Les données personnelles que vous nous communiquez servent à la gestion et au traitement de vos
                commandes. Elles sont ensuite transmises à notre transporteur afin qu'il puisse vous livrer votre
                commande.
              </p>
              <p>
                La collecte et le traitement de vos données personnelles reposent principalement sur la relation
                contractuelle que vous avez avec nous.
              </p>
              <p>
                Si vous ne nous fournissez pas ces données nous ne serons pas en mesure de conclure de contrat avec vous
                et de traiter votre commande.
              </p>
              <p>
                Vos données ne pourront être utilisées à d'autres fins ni être vendues ou communiquées à des tiers sans
                votre autorisation préalable.
              </p>
              <p>
                Lors de votre inscription, vous garantissez que les données que vous nous communiquez sont exactes et
                conformes à la réalité. Vous vous engagez à nous informer en cas de modification de vos données et, le
                cas échéant, à procéder vous-même aux modifications correspondantes au sein de votre espace personnel
                sur notre site.
              </p>
              <p>
                Le responsable du traitement de vos données personnelles est la société REGARD DE NATURE – Naturopathie
                & Iridologie, qui a son siège au XXX et qui est représentée par Madame Laura ELIE, joignable à la même
                adresse.
              </p>
              <p>
                Conformément à la loi, nous conservons ces informations dans des conditions de sécurité renforcées et
                pour des durées limitées, proportionnelles aux finalités pour lesquelles vous les avez communiquées,
                notamment la durée nécessaire à votre information et/ou au traitement de vos commandes. Nous nous
                engageons à ne pas conserver vos données personnelles au-delà de la durée nécessaire à la fourniture du
                service, augmentée de la durée de conservation imposée par les règles applicables en matière de
                prescription légale.
              </p>
              <p>
                Conformément à la loi, toute personne peut obtenir communication et, le cas échéant, rectification ou
                suppression des informations la concernant ou s'opposer à ce que ces données soient traitées ou limiter
                ce traitement ou demander la portabilité de ses données personnelles (dans les cas et limites prévus par
                le Règlement UE 2016/679), en écrivant au service « Protection des données personnelles » à l'adresse
                suivante :
              </p>
              <p>
                REGARD DE NATURE – Naturopathie pour petits & grands
                <br />
                31 rue de l'ancien petit fossé
                <br />
                31450 Montesquieu-Lauraguais
                <br />
                France
                <br />
                <br />
                Email : contact@regard-de-nature.fr
              </p>
              <p>Toutes vos demandes doivent être accompagnées d'un justificatif d'identité.</p>
              <p>
                Vous avez également le droit de déposer une réclamation auprès de l'autorité de contrôle compétente (la
                C.N.I.L.), si vous estimez que nous ne respectons pas vos droits.
              </p>
              <p>
                Toute information, notamment la copie des données personnelles collectées ou les autres informations
                prévues par la loi susvisée, peut être délivrée gratuitement sous réserve qu'une telle demande ne soit
                pas manifestement abusive, notamment par son caractère répétitif ou systématique.
              </p>
              <p>
                Internet étant un réseau ouvert, nous ne pouvons garantir que ces données ne seront pas détournées par
                des tiers malgré les mesures de protection que nous mettons en place.
              </p>
            </div>

            <div className="space-y-3">
              <h4 className="font-semibold text-primary text-base">
                Article 9 – Service clientèle et service après-vente
              </h4>
              <p>
                Pour toute information ou question, vous pouvez appeler au 06 37 03 18 66 ou nous contacter à l'adresse
                suivante :
              </p>
              <p>contact@regard-de-nature.fr</p>
            </div>
          </div>
        </ScrollArea>
      </SheetContent>
    </Sheet>
  );
}
